import { getServiceURL } from './transportWrapper';

import { IReportCreator, ISession, IUser } from './types';

const usersApi = (hostUrl?: string) => getServiceURL(hostUrl || process.env.USERS_SERVICE_HOST);

function limitQueryParam(limit) {
  return limit ? `&limit=${limit}` : '';
}

export const usersByEntityId = async (
  id: number | string,
  clientOptions: RequestInit = {},
  userFields?: string[],
  limit?: number,
  hostUrl?: string
): Promise<Partial<ISession>[]> => {
  return usersApi(hostUrl)
    .options(clientOptions, true)
    .url(`/api/v1/users`)
    .query({
      entity_id: id,
      ...(limit && { limit }),
      ...(userFields && { fields: userFields.join(',') })
    })
    .get()
    .json()
    .then((response) => response.users);
};

export const userByRole = async (
  id: number | string,
  userRole: string,
  clientOptions: RequestInit = {},
  limit?: string,
  hostUrl?: string
) => {
  const limitParam = limitQueryParam(limit);
  return usersApi(hostUrl)
    .options(clientOptions, true)
    .url(`/api/v1/users?entity_id=${id}&role=${userRole}${limitParam}`)
    .get()
    .json()
    .then((user: IUser): IUser => {
      return user;
    });
};

export const getUserFieldsByUuid = async (
  uuid: string,
  fields: string[],
  clientOptions: RequestInit = {},
  hostUrl?: string
): Promise<IReportCreator> => {
  return usersApi(hostUrl)
    .options(clientOptions, true)
    .url(`/api/v1/users/${uuid}`)
    .query({ fields: fields.join(',') })
    .get()
    .json()
    .then((response: ISession) => {
      if (!response.uuid) {
        return { is_admin: true, uuid } as IReportCreator;
      }
      return response as IReportCreator;
    })
    .catch((err) => {
      if (err.status === 404) {
        return { uuid, not_found: true } as IReportCreator;
      }
      throw err;
    });
};

export const getFullNameByUuid = async (
  uuid: string,
  clientOptions: RequestInit = {},
  hostUrl?: string
): Promise<IReportCreator> => getUserFieldsByUuid(uuid, ['full_name', 'uuid'], clientOptions, hostUrl);

export const deleteUserById = async (userId: string | number, clientOptions?: RequestInit, hostUrl?: string) =>
  usersApi(hostUrl).options(clientOptions, true).url(`/api/v1/users/${userId}`).delete();

export const promoteUserById = async (id: string, clientOptions?: RequestInit, hostUrl?: string) =>
  usersApi(hostUrl).options(clientOptions, true).url(`/api/v1/users/${id}/promote`).post();

export const demoteUserById = async (id: string, clientOptions?: RequestInit, hostUrl?: string) =>
  usersApi(hostUrl).options(clientOptions, true).url(`/api/v1/users/${id}/demote`).post();
